var _defs, _path, _path2, _rect, _rect2, _path3, _path4, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2Pocket01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-7{fill:none;}.cls-7,.cls-6,.cls-5{stroke:#010101;stroke-miterlimit:10;}.cls-7,.cls-5{stroke-width:2.7px;}.cls-6,.cls-5{fill:#fff;}.cls-6{stroke-width:0.9px;stroke-dasharray:2.7;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M356.85,141.89V320.67a39.43,39.43,0,0,1-39.42,39.42H153.72a39.43,39.43,0,0,1-39.42-39.42V141.89Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M153.72,357.38A36.75,36.75,0,0,1,117,320.67V144.59H354.14V320.67a36.75,36.75,0,0,1-36.71,36.71Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 114.3,
    y: 95,
    width: 242.55,
    height: 46.89
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 117.01,
    y: 97.7,
    width: 237.14,
    height: 41.48
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M308.7,195.86V374.64a39.43,39.43,0,0,1-39.42,39.42H105.57a39.43,39.43,0,0,1-39.42-39.42V195.86Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M105.57,411.36a36.76,36.76,0,0,1-36.71-36.72V198.57H306V374.64a36.76,36.76,0,0,1-36.71,36.72Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 66.15,
    y: 148.98,
    width: 242.55,
    height: 46.89
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 68.86,
    y: 151.68,
    width: 237.14,
    height: 41.48
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Pocket01);
export default __webpack_public_path__ + "static/media/2 POCKET-01.3564d3518ebc7e706615fb88651e639e.svg";
export { ForwardRef as ReactComponent };